import { ArticlesExample, EmbedLevel, PricesExample } from '@/containers/widget/embedScript';
import {
    SetArticleQuantityCommand,
    SetPriceQuantityCommand,
} from '@/containers/widget/useWidgetPreview';
import { WidgetConfigurationResponse } from '@/types/types';

export interface CustomerFormValues {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

export interface EmbedPageState {
    level: EmbedLevel;
    configurationId: string | null;
    fitViewport: boolean;
    articlesExample: ArticlesExample;
    articleId: string;
    quantity: string;
    syncedArticleIds: number[];
    pricesExample: PricesExample;
    priceId: string;
    priceQuantity: string;
    syncedPriceIds: number[];
    customer: CustomerFormValues;
}

export type StoredConfiguration = WidgetConfigurationResponse & { Id: string };

export const INITIAL_EMBED_PAGE_STATE: EmbedPageState = {
    level: 'basic',
    configurationId: null,
    fitViewport: true,
    articlesExample: 'helper',
    articleId: '',
    quantity: '1',
    syncedArticleIds: [],
    pricesExample: 'helper',
    priceId: '',
    priceQuantity: '1',
    syncedPriceIds: [],
    customer: {
        firstName: 'Ada',
        lastName: 'Lovelace',
        email: 'ada@example.com',
        phone: '+46701234567',
    },
};

const NON_NEGATIVE_INTEGER = /^\d+$/;

export const parseOptionalNonNegativeInteger = (raw: string): number | undefined => {
    const trimmed = raw.trim();
    return NON_NEGATIVE_INTEGER.test(trimmed) ? Number(trimmed) : undefined;
};

export const hasConfigurationId = (
    configuration: WidgetConfigurationResponse
): configuration is StoredConfiguration => typeof configuration.Id === 'string';

export const pickDefaultConfigurationId = (
    configurations: WidgetConfigurationResponse[]
): string | null => {
    const stored = configurations.filter(hasConfigurationId);
    const preferred = stored.find((configuration) => configuration.IsHomepageDefault) ?? stored[0];
    return preferred?.Id ?? null;
};

export const parseArticleCommand = (
    articleId: string,
    quantity: string
): SetArticleQuantityCommand | null => {
    const parsedArticleId = parseOptionalNonNegativeInteger(articleId);
    const parsedQuantity = parseOptionalNonNegativeInteger(quantity);
    if (!parsedArticleId || parsedQuantity === undefined) return null;
    return { articleId: parsedArticleId, quantity: parsedQuantity };
};

export const parsePriceCommand = (
    priceId: string,
    quantity: string
): SetPriceQuantityCommand | null => {
    const parsedPriceId = parseOptionalNonNegativeInteger(priceId);
    const parsedQuantity = parseOptionalNonNegativeInteger(quantity);
    if (parsedPriceId === undefined || parsedQuantity === undefined) return null;
    return { priceId: parsedPriceId, quantity: parsedQuantity };
};
